module.exports = __webpack_public_path__ + "23_arxiv.jpg?5fe242206324549d3c7db3a6d112d763";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_arxiv.jpg
// module id = 191
// module chunks = 0